import { Component, computed, input } from '@angular/core';

import { LazyDirective } from './lazy/lazy.directive';

type LazyComponentFactory = (() => Promise<unknown>) | undefined;
interface LazyConfig {
  component?: LazyComponentFactory;
}

@Component({
    selector: 'app-component-loader',
    imports: [LazyDirective],
    templateUrl: './component-loader.component.html',
    styleUrls: ['./component-loader.component.scss']
})
export class ComponentLoader {

  readonly selector = input.required<string>();
  readonly inputs = input<any>();
  readonly outputs = input<any>();
  readonly lazyConfig = computed<LazyConfig>(() => ({
    component: this.getPath()
  }));

  getPath() {
    switch (true) {

      case this.selector() === 'app-signin-signup':
        return () => import('../signin-signup/signin-signup.component');

      case this.selector() === 'testing':
        return () => import('../testing/testing.component');

      default:
        return;
    }
  }

}
